import { createAsyncThunk } from "@reduxjs/toolkit"

import type { IOneVerifyPayerStatus } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { PayerStatusService } from "../../services/payerStatus.service"
import type { IThunkActionData } from "../../types/general.types"
import {
    runtimeStartLoading,
    runtimeStopLoading,
} from "../slices/runtime.slice"

/**
 * Get payer status
 */
export const payerStatusGet = createAsyncThunk<
    IOneVerifyPayerStatus | null,
    IThunkActionData<null>
>("payerStatusGetPrefix", async (action, { dispatch }) => {
    if (!action.ignorePreloader) {
        dispatch(runtimeStartLoading("payerStatusGetLoading"))
    }

    let result: IOneVerifyPayerStatus | null = null

    try {
        result = await PayerStatusService.getPayerStatus()

        if (result) {
            action.onSuccess?.(result)
        } else {
            action.onError?.(result)
        }

        return result
    } catch (e) {
        action.onError?.(null)

        return null
    } finally {
        if (!action.ignorePreloader) {
            dispatch(runtimeStopLoading("payerStatusGetLoading"))
        }

        action.onFinally?.()
    }
})
